import React from 'react';
import * as ReactDOM from 'react-dom/client';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import App from './app';
import { environment } from './environments/environment';

const root = ReactDOM.createRoot(document.getElementById('root'));
const origin = window.location.origin;
const PROD_URL = 'https://aps.autopass.xyz';

const queryClient = new QueryClient();

Sentry.init({
  environment: origin === PROD_URL ? 'production' : 'alpha',
  dsn: environment.sentryDSN,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
});

root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
);
